
<mat-dialog-content>
  <div style="display: flex;">
    <div style="width: 100%">
      <h1 style="font-size: 1.5rem">Select Product</h1>
    </div>
  
    <lib-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </lib-icon-button>
  </div>

  
  <div>
    <div style="display: flex; padding: 1rem 0">
      <div style="width:75%"><b>Name</b></div>
      <div style="width:25%"><b>Quantity</b></div>
    </div>
    
    <ng-template [ngIf]="!loading">
      <div *ngFor="let product of products" style="display: flex;">
        <div style="width:75%">{{ product.name }}</div>
        <div style="width:25%">
          <lib-number-input
            style="width: 100%"
            [default_value]="0"
            (onChange)="updateQuantity($event, product)" 
          />
        </div>
      </div>
    </ng-template>

    <lib-content-loader *ngIf="loading" />
    
  </div>

</mat-dialog-content>

<mat-dialog-actions style="gap: 0.8rem" align="end">
  <lib-button mat-dialog-close>Cancel</lib-button>
  <lib-button type="primary" (click)="checkout()">Checkout</lib-button>
</mat-dialog-actions>